// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__sCdBw","icon":"SortAdornment_icon__-rfuP","up":"SortAdornment_up__kEbw9","down":"SortAdornment_down__2bcm8","active":"SortAdornment_active__LyCCO"};